function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eyeonglyph)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.25 9.6A6.97 6.97 0 017.99 4c3.2 0 6.06 2.33 6.74 5.6a.5.5 0 00.98-.2A7.97 7.97 0 007.99 3 7.98 7.98 0 00.27 9.4a.5.5 0 10.98.2zM7.98 6a3.5 3.5 0 110 7 3.5 3.5 0 010-7z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "eyeonglyph"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));